/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CommentVisibleIcon from '../../../../../assets/images/commen-visible-icon.svg';
import CommentIcon from '../../../../../assets/images/comment-dots.svg';
import {
  deletePlanHandleFromGridComponent,
  dispatchDeletePlanDetails,
  softDeleteRowData,
  updateDatesRows,
} from '../../store/actions';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import SaveCancelPopup from '../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';

export default ({
  cellInfo,
  setCorrLinkId,
  setShowComments,
  setRowGridPrimaryKey,
  handleClickOpenDelete,
  setDisabledSaveCancelBtn,
  isEnablebyRole,
}) => {
  const datesRows = useSelector((state) => {
    return state.sharedState.PlanReducer.datesRows;
  });
  const dispatch = useDispatch();
  const [openDelete, setOpenDelete] = useState(false);

  const onDeleteClicked = () => {
    let updatedArray = datesRows;
    updatedArray = datesRows.map((item) => {
      if (item.index === cellInfo?.node?.data?.index)
        item['deleteRecord'] = true;
      return item;
    });
    dispatch(updateDatesRows(updatedArray));
    setDisabledSaveCancelBtn(false);
  };

  return (
    <>
      <SaveCancelPopup
        open={openDelete}
        title='Delete'
        moduleName='the selected record'
        onConfim={() => {
          setOpenDelete(false);
          onDeleteClicked();
        }}
        onCancel={() => {
          setOpenDelete(false);
        }}
      />
      <div className='tdCell icon-btn-group'>
        <OverlayTrigger
          placement='bottom'
          overlay={<Tooltip id='delete-tooltip'>Delete</Tooltip>}
        >
          <Button
            data-testid='deleteBtn'
            className='th-ic trash-blue'
            variant='text'
            onClick={() => {
              if (datesRows?.filter((item) => !item.deleteRecord)?.length > 1) {
                setOpenDelete(true);
              } else {
                handleClickOpenDelete && handleClickOpenDelete();
              }
            }}
            aria-label='Delete'
            disabled={!isEnablebyRole}
          >
            <SVGComponent iconName='Icon-delete' />
          </Button>
        </OverlayTrigger>
        <OverlayTrigger
          placement='bottom'
          overlay={<Tooltip id='com-tooltip'>Comment</Tooltip>}
        >
          <Button
            className='th-ic comment-ic'
            variant='text'
            aria-label='comment'
          >
            <Button
              className='th-ic comment-ic'
              variant='text'
              onClick={() => {
                setCorrLinkId(cellInfo.data.corrLinkId);
                setRowGridPrimaryKey(cellInfo?.data);
                setShowComments(true);
              }}
              tabIndex={'0'}
              onKeyDown={(e) => {
                // Handle Enter and Space key events
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault(); // Prevents the default space scrolling behavior
                  setCorrLinkId(cellInfo.data.corrLinkId);
                  setRowGridPrimaryKey(cellInfo?.data);
                  setShowComments(true);
                }
              }}
              aria-label='comment'
              disabled={!isEnablebyRole}
            >
              {parseInt(cellInfo.data.ccCommentsExist, [0, 1]) === 1 ? (
                <img role='button' alt='comment' src={CommentVisibleIcon} />
              ) : (
                <img alt='' src={CommentIcon} />
              )}
            </Button>
          </Button>
        </OverlayTrigger>
      </div>
    </>
  );
};
